import { useState } from 'react'

import { Box, Typography } from '@mui/material'
import { brainstormText } from 'content/brainstormText'

import InfoPopper from 'components/InfoPopper'

import { styles } from './Section2Title.styles'

export type Section2TitleGameType =
	| 'oppositeDay'
	| 'dressUp'
	| 'simonSays'
	| 'battleShips'
	| 'leapFrog'
	| 'teeterTotter'
	| 'musicalChairs'
	| 'roundRobin'

type Props = {
	gameType?: Section2TitleGameType
	showInfoPopper?: boolean
}

const Section2Title = ({ gameType, showInfoPopper = true }: Props) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

	const handleClickInfoIcon = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(anchorEl ? null : event.currentTarget)
	}

	const section2TitlePopperContentByGame = (
		brainstormText as typeof brainstormText & {
			section2TitlePopperContentByGame?: Record<
				Section2TitleGameType,
				{ bulletItems: unknown[]; introText: string }
			>
		}
	).section2TitlePopperContentByGame

	const getPopperContent = () => ({
		header: 'Technique Context:',
		introText:
			(gameType &&
				section2TitlePopperContentByGame[gameType]?.introText) ||
			'This section introduces your facilitation technique and guidance for how to apply it during ideation.',
		bulletItems:
			(gameType &&
				section2TitlePopperContentByGame[gameType]?.bulletItems) ||
			[],
	})

	return (
		<Box sx={styles.container}>
			<Typography sx={styles.title} data-testid={'section-2-title'}>
				FACILITATION TECHNIQUE
			</Typography>
			{showInfoPopper && (
				<InfoPopper
					handleClick={handleClickInfoIcon}
					anchorEl={anchorEl}
					popperContent={getPopperContent()}
					id={`section-2-title-info-popper-${gameType}`}
				/>
			)}
		</Box>
	)
}

export default Section2Title
